import { useState } from "react";
import useApi from "../../api";
import { NXDelete, NXEyes } from "../../icons";
import { useDeleteConfirmation } from "../common";
import GenericSelectableTable from "../selectableTable";
import StockView from "./StockView";
import QuantityEditor from "./quantityEditor";


interface StockTableProps {
    data: any;
    refresh: ()=>void;
}

function StocksTable({data, refresh}:StockTableProps) {
  const [stockId, setStockId] = useState<any>(null)
  const {handleDelete}  = useDeleteConfirmation()
  const api = useApi()

  const columns = [
    { header: "ID", key: "id", render:(item:any)=>(
      <div className="text-base-300 text-sm">
        #ID {item.id}
      </div>
    )},
    { header: "Warehouse", key: "warehouse_name" },
    { header: "Product variant", key: "product_variant_name" },
    { header: "Quantity", key: "quantity", render: (item: any) => {
      return (
        <QuantityEditor 
          quantity={item.quantity} 
          variant_id={item.product_variant} 
          warehouse_id={item.warehouse} 
          onSave={refresh}
        />
      );
    }},
    { header: 'reserved', key: 'reserved' },
    { header: 'Available', key: 'available_for_new_order' },
    { header: "Action", key: "action", render: (item:any)=>(
      <div className="flex gap-1 items-center">
        <button onClick={() => setStockId(item.id)}>
          <NXEyes className="text-primary-400" />
        </button>
        <button
          className="p-1"
          onClick={() => {
            handleDelete(
              item.id,
              "Stock",
              api.deleteStock,
              refresh
            );
          }}
        >
          <NXDelete className="text-red-600" />
        </button>
      </div>
    )},

  ]
 
  return (
    <div>
      <div className="overflow-x-auto">
        <GenericSelectableTable columns={columns} data={data}/>
      </div>
      <StockView id={stockId} isOpen={stockId ? true : false} onClose={()=>setStockId(null)}/>
    </div>
  )
}

export default StocksTable